import { render } from "./AiChart.vue?vue&type=template&id=4a6a6305"
import script from "./AiChart.vue?vue&type=script&lang=js"
export * from "./AiChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__